(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ds-faq-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-ds-faq-destination]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, location.href);
    if(destination.origin !== location.origin || destination.pathname !== location.pathname || destination.search !== location.search) return;
    const faq = document.querySelector('[data-ds-faq]');
    const target = document.getElementById(destination.hash.slice(1));
    if(!faq || !target) return;
    event.preventDefault();
    const header = link.closest('[data-ds-shared-header]');
    const dialog = header?.querySelector('#ds-mobile-nav[open]');
    if(dialog) dialog.querySelector('[data-dsh-mobile-panel="faqs"] [data-dsh-close]').click();
    else window.DSHeader?.hide();
    requestAnimationFrame(() => {
      const topic = [...faq.querySelectorAll('[data-faq-topic]')].find(anchor => anchor.getAttribute('href') === destination.hash);
      if(topic) topic.click();
      else {
        const input = faq.querySelector('[data-faq-search]');
        input.value='';
        input.dispatchEvent(new Event('input',{bubbles:true}));
        const heading=faq.querySelector('h1');
        heading.setAttribute('tabindex','-1');
        heading.focus({preventScroll:true});
        faq.scrollIntoView({block:'start'});
        history.replaceState(null,'',destination.hash);
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ds-journal-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-ds-journal-destination]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin === location.origin && destination.pathname === location.pathname && destination.search === location.search) window.DSHeader?.hide();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
